export default "__VITE_ASSET__B5q3zkGP__"